import React, { Component } from 'react';
import { Toast } from 'antd-mobile';
import queryString from 'query-string';
import styles from './styles.module.less';
import { getImAppId, getImOpenId } from '../../service/chat-service';
import WXShare from '../../components/WxShare';
import tools from '../../utils/tools';
import yaoq from './img/yaoqing.jpg';

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      wxName: '',
      wxUrl: '',
      token: '',
    };
  }

  componentDidMount() {
    document.title = '邀请讲师';
    this.getLiveOpenId(); // 微信授权获取微信信息
  }

    getLiveOpenId = async () => {
      const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
      const WXCode = queryString.parse(windowHref).code;
      this.setState({
        token: queryString.parse(windowHref).token,
      });
      if (!WXCode) {
        localStorage.clear();
        try {
          const { code, data, message } = await getImAppId();
          if (process.env.REACT_APP_API_ENV === 'local') {
            // 本地测试时不走微信验证
            //   this.getLiveDetailLiveInfo('oQd0LwJcSPgP7eYwSy38bUdb793A', 1)
          } else if (code === 10000) window.location.href = tools.toWxth(data);
          else Toast.show(message || '获取微信 appId 失败');
        } catch (e) {
          Toast.show('获取微信 appId 失败');
        }
      } else if (!localStorage.getItem('openId')) {
        try {
          const { code, data } = await getImOpenId(WXCode, 1);
          if (code === 10000) {
            localStorage.setItem('openId', data.openid);
            this.setState({
              isShow: true,
              wxName: data.nickname,
              wxUrl: data.headimgurl,
            });
          }
        } catch (e) {
          Toast.show(e);
        }
      }
    }

    render() {
      const {
        isShow, wxName, wxUrl, token,
      } = this.state;
      return (
        <div className={styles.box}>
          <div><img src={yaoq} alt="" /></div>
          {
            isShow
            && (
            <WXShare
              title="邀请函"
              imgUrl={wxUrl}
              desc={`${wxName}邀请您成为讲师`}
              link={`${window.location.origin}/test/webapp/invitation?${
                encodeURIComponent(`token=${token}&wxName=${wxName}&wxUrl=${wxUrl}`)}`}
            />
            )
              }
        </div>
      );
    }
}

export default index;
